import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import ClientWiseSummaryDownloadModalUI from './ClientWiseSummaryDownloadModalUI.js'

class ClientWiseSummaryDownloadModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      // form events
      submitted: false,
      // form field
      startDate: '',
      startDateError: null,
      endDate: '',
      endDateError: null
    }
  }

  render() {
    return (
      <ClientWiseSummaryDownloadModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        downloadMode={this.props.downloadMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onCancelClick}
        // form fields
        startDate={this.state.startDate}
        onStartDateChange={(startDate) => { this.setState({ startDate: startDate }) }}
        startDateError={this.state.startDateError}
        setStartDateError={(error) => { this.setState({ startDateError: error }) }}
        //
        endDate={this.state.endDate}
        onEndDateChange={(endDate) => { this.setState({ endDate: endDate }) }}
        endDateError={this.state.endDateError}
        setEndDateError={(error) => { this.setState({ endDateError: error }) }}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    let context = this.props.context
    RestApiUtils.get(context,
      `/api/su/nodalBankAccounts/${this.props.accountNumber}/bankTransactions/excel/fileDownloadSignedUrl/dates`,
      this.onSubmitCallback, null,
      {
        startDateISO: this.state.startDate,
        endDateISO: this.state.endDate,
      }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      const link = document.createElement('a')
      link.href = response.signedUrl.signedUrl
      // link.setAttribute('download', 'bank_statement_template.pdf');
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)

      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onCancelClick()
      }, 2000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default withRouter(ClientWiseSummaryDownloadModalSF)
